import { themeAlpine } from 'ag-grid-community';
import { createGlobalStyle, useTheme } from 'styled-components';

export const GlobalTableTheme = createGlobalStyle`
  [class*=ag-theme-] {
    --ag-border-color: ${({ theme }) => theme.colors.neutral[100]};
    --ag-border-width: 1px;
    --ag-border-style: solid;
    --ag-selected-row-background-color: ${({ theme }) => theme.colors.purple[100]};
    --ag-cell-horizontal-border: 1px solid var(--ag-border-color);
    --ag-cell-horizontal-padding: 0px;
    --ag-control-panel-background-color: ${({ theme }) => theme.colors.neutral[0]};
    --ag-popup-shadow: 0px 4px 16px 0px rgba(27,36,50,0.10),0px 1px 8px 0px rgba(27,36,50,0.10);
    --ag-foreground-color: ${({ theme }) => theme.colors.text.main};
    --ag-row-border-color: ${({ theme }) => theme.colors.neutral[0]};

    --ag-range-selection-background-color: ${({ theme }) => theme.colors.purple[100]};
    --ag-range-selection-border-color: ${({ theme }) => theme.colors.purple[300]};
    --ag-range-selection-border-style: solid;
    --ag-range-selection-border-width: 1px;


    .ag-root-wrapper {
      border-left: none;
      border-right: none;

      // disable group expand/collapse icons
      .ag-group-expanded,
      .ag-group-contracted {
        display: none;
      }
    }

    /* .ag-pinned-left-header, */
    .ag-header-cell-checkbox,
    .ag-column-checkbox {
      border: none;
      background-color: transparent !important;
    }
  
    .ag-column-checkbox {
      border-bottom: 1px solid var(--ag-border-color);
      & .ag-cell:focus {
        outline: none;
        background-color: transparent;
      }
    }

    // add border to all cells except first column
    .ag-cell:not(.ag-column-first):not(.ag-cell-range-selected):not(.ag-cell-focus) {
      border-bottom: 1px solid var(--ag-border-color);
    }

    // remove border from loader cell
    .span-load-more-cell {
      .ag-cell:not(.ag-column-first):not(.ag-cell-range-selected) {
        border-right: none;
      }
    }

    .ag-pinned-right-cols-container {
      .span-load-more-cell, .ag-row {
        .ag-cell:not(.ag-column-first):not(.ag-cell-range-selected):last-child {
          border-right: 1px solid var(--ag-border-color);
        }
      }
    }

    .ag-row-group-expanded,
    .ag-row-group-contracted {
      .ag-cell:not(.ag-cell-range-selected) {
        border-right: none;
      }

      .ag-cell.ag-column-first:not(.ag-cell-range-selected) {
        border-bottom: 1px solid var(--ag-border-color);
      }
    }

    .last-row {
      .ag-cell:not(.ag-cell-range-selected) {
        border-bottom: 1px solid var(--ag-border-color);
      }
    }
  
    .ag-row-hover {
      background-color: ${({ theme }) => theme.colors.neutral[20]};
    }

    .ag-row-first {
      border-top: none;
    }

    .ag-header-cell {
      border-right: 1px solid var(--ag-border-color);
    }

    .ag-pinned-right-header {
      .ag-column-last .ag-header-cell-comp-wrapper {
        border-right: 1px solid var(--ag-border-color);
      }
    }

    .ag-group-value {
      width: 100%;
    }
    .ag-header-cell.ag-column-first {
      border-right: none;
    }

    .ag-column-first {
      border-left: ${({ enableLeftTableBorder }) =>
        enableLeftTableBorder ? '1px solid var(--ag-border-color)' : 'none'};
    }

    .no-contacts {
      .ag-cell-no-contacts:not(.ag-cell-range-selected):not(.ag-column-last) {
        border-right: none !important;
      }
    }

    scrollbar-width: thin;
    scrollbar-color: #dee3ed transparent;
  }

`;

export const useTableTheme = () => {
  const fontFamily = ['Silka', 'Helvetica', 'Arial', 'sans-serif'];
  const theme = useTheme();
  const tableTheme = themeAlpine.withParams({
    accentColor: '#4900FF',
    browserColorScheme: 'light',
    cellTextColor: theme.colors.text.main,
    headerBackgroundColor: theme.colors.neutral[0],
    headerFontFamily: fontFamily,
    fontFamily,
    cellFontFamily: fontFamily,
    headerFontSize: 12,
    headerFontWeight: 400,
    headerTextColor: theme.colors.text.subtle,
    borderColor: theme.colors.neutral[100],
    cellHorizontalPadding: 16,
    cellVerticalPadding: 16,
    wrapperBorder: false,
    headerRowBorder: true,
    columnBorder: true,
    rowBorder: {
      width: 1,
      color: theme.colors.neutral[100],
      style: 'solid',
    },
    menuBackgroundColor: theme.colors.purple[0],
  });

  return tableTheme;
};
